import React from "react";

const NoImage = ({ data, noImageClass }) => {
  return (
    <div className={noImageClass} aria-hidden="true">
      <p>
        {data?.length === 1 ? data?.[0]?.[0] : data?.[0]?.[0]}

        {data?.length !== 1 && data?.[1]?.[0]}
      </p>
    </div>
  );
};

export default NoImage;
